<div class="grid flex-column" *ngIf="document as doc">
  <div class="col">
    <div class="fluid formgrid grid">
      <div class="xl:col-4 sm:col-12">
        <app-companyselector [labelKey]="manCliLabel" [parentCompany]="0" [selectedID]="doc.DOCMANCLIID" disabled="true"></app-companyselector>
      </div>
      <div class="xl:col-4 sm:col-12">
        <app-personselector [labelKey]="manPerLabel" [parentCompany]="doc.DOCMANCLIID" [selectedID]="doc.DOCMANPERID" disabled="true"
                            (selectedPersonID)="mainPersonSelected($event)"></app-personselector>
      </div>
      <div class="xl:col-4 sm:col-12">
        <app-departmentselector [labelKey]="manDepLabel" [parentCompany]="doc.DOCMANCLIID" [selectedID]="doc.DOCMANDEPID"
                                (selectedDepartmentID)="mainStockSelected($event)"></app-departmentselector>
      </div>
    </div>
  </div>
  <div class="col">
    <div class="fluid formgrid grid">
      <div class="xl:col-4 sm:col-12">
        <app-companyselector [labelKey]="lcoCliLabel" [parentCompany]="doc.DOCMANCLIID" [selectedID]="doc.DOCLCOCLIID"
                             (selectedCompanyID)="lcoCompanySelected($event)" disabled="true"></app-companyselector>
      </div>
      <div class="xl:col-4 sm:col-12">
        <app-personselector [labelKey]="lcoPerLabel" [parentCompany]="doc.DOCLCOCLIID" [selectedID]="doc.DOCLCOPERID" select="sign"
                            (selectedPersonID)="lcoPersonSelected($event)"></app-personselector>
      </div>
      <div class="xl:col-4 sm:col-12">
        <app-departmentselector [labelKey]="lcoDepLabel"
                                [disabled]="true"
                                [parentCompany]="doc.DOCLCOCLIID"
                                [selectedID]="doc.DOCLCODEPID"
                                [masterID]="doc.DOCMANDEPID"
                                (selectedDepartmentID)="lcoStockSelected($event)">
        </app-departmentselector>
      </div>
    </div>
  </div>
</div>
